import { render, staticRenderFns } from "./SkupEdit.vue?vue&type=template&id=181109a3&scoped=true&"
import script from "./SkupEdit.vue?vue&type=script&lang=js&"
export * from "./SkupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181109a3",
  null
  
)

export default component.exports